const API_URL = import.meta.env["VITE_API_URL"] as string;

export const TRPC_URL = `${API_URL}/trpc`;

export const DEFAULT_AUTHENTICATED_ROUTE = "/welcome";

export const SUPPLIER_ROUTES = {
  list: "/suppliers",
  contactsList: "/suppliers/contacts",
  detail: "/suppliers/$supplierId",
  pricedDeliverables: "/suppliers/$supplierId/priced-deliverables",
  importedCatalog: "/suppliers/$supplierId/imported-catalog",
  catalogPrices: "/suppliers/$supplierId/catalog-prices",
  contacts: "/suppliers/$supplierId/contacts",
} as const;

export const SUPPLIER_DETAIL_ROUTE_ID = "/_auth/_frame/suppliers/$supplierId";
